type Entity = { id: string } & Record<string, unknown>;

interface ClientWithUsers {
  users: {
    find: (id: string, options?: { organizationId?: string }) => Promise<Entity | null>;
  };
}

interface Args {
  client: ClientWithUsers;
  organizationId: string;
  excludeIds: string[];
  recipients: string | undefined;
}

export async function resolveRecipients({
  client,
  organizationId,
  excludeIds,
  recipients,
}: Args): Promise<Entity[]> {
  if (!recipients) return [];

  const emails = Array.from(
    new Set(
      recipients
        .split(',')
        .map((e) => e.trim())
        .filter((e) => e.length > 0)
    )
  );
  if (emails.length === 0) return [];

  const settled = await Promise.allSettled(
    emails.map((email) => client.users.find(email, { organizationId }))
  );

  return settled.flatMap((result) => {
    if (result.status === 'rejected' || !result.value) return [];
    const user = result.value;
    if (excludeIds.includes(user.id)) return [];
    return [user];
  });
}
